var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.webShareApiSupported)?_c('div',{staticClass:"share-button mx-1 pointer w-8 h-8",on:{"click":function($event){$event.preventDefault();return _vm.share.apply(null, arguments)}}},[_c('svg-vue',{staticClass:"dark:text-white",attrs:{"icon":'share'}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }